import { RUBLE_SIGN } from 'lib/constants';
import { squareMetre } from 'lib/types';
import { number, object, string } from 'yup';

export interface ISchemaDataNotificationFilter {
  title: string;
  priceTo: number | null;
  priceFrom: number | null;
  areaTo: number | null;
  areaFrom: number | null;
  pricePerSqMTo: number | null;
  pricePerSqMFrom: number | null;
}

export const notificationFilterSchema = object<ISchemaDataNotificationFilter>({
  title: string().required('Заполните название уведомления'),
  priceFrom: number()
    .test({
      name: 'priceFrom',
      message: 'Укажите значение цены ',
      test: (val, form) => {
        const data = form.parent as ISchemaDataNotificationFilter;

        if (
          (data.priceFrom !== null && data.priceTo === null) ||
          (data.priceFrom == null && data.priceTo !== null)
        ) {
          return false;
        }

        const isEmptyNecessary =
          !data.pricePerSqMFrom && !data.pricePerSqMTo && !data.areaFrom && !data.areaTo;

        if (isEmptyNecessary && val === null) {
          return false;
        } else {
          if (val !== null && data.priceTo && val! > data.priceTo) {
            return false;
          }
          return true;
        }
      },
    })
    .nullable(),
  priceTo: number()
    .test(
      'priceTo',
      `Значение не указано или ценовой диапазон привышает 5 000 000 ${RUBLE_SIGN} `,
      (val, form) => {
        const data = form.parent as ISchemaDataNotificationFilter;

        if (
          (data.priceFrom !== null && data.priceTo === null) ||
          (data.priceFrom == null && data.priceTo !== null)
        ) {
          return false;
        }

        const isEmptyNecessary =
          !data.pricePerSqMFrom && !data.pricePerSqMTo && !data.areaFrom && !data.areaTo;

        if (isEmptyNecessary && !val) {
          return false;
        } else {
          const isInvalid = val && data?.priceFrom !== null && val > data.priceFrom + 5000000;
          if ((val && data.priceFrom && val < data.priceFrom) || isInvalid) {
            return false;
          }
          return true;
        }
      },
    )
    .nullable(),
  areaTo: number()
    .test(
      'areaTo',
      `Значение не указано или указаный диапазон привышает 40 ${squareMetre}`,
      (val, form) => {
        const data = form.parent as ISchemaDataNotificationFilter;

        if (
          (data.areaTo !== null && data.areaFrom === null) ||
          (data.areaTo == null && data.areaFrom !== null)
        ) {
          return false;
        }

        const isEmptyNecessary =
          !data.pricePerSqMFrom && !data.pricePerSqMTo && !data.priceFrom && !data.priceTo;

        if (isEmptyNecessary && !val) {
          return false;
        } else {
          const isInvalid = val && data.areaFrom !== null && val > Number(data.areaFrom) + 40;
          if ((val !== null && data.areaFrom && val! < data.areaFrom) || isInvalid) {
            return false;
          }
          return true;
        }
      },
    )
    .nullable(),
  areaFrom: number()
    .test('areaFrom', 'Укажите значение площади', (val, form) => {
      const data = form.parent as ISchemaDataNotificationFilter;

      if (
        (data.areaTo !== null && data.areaFrom === null) ||
        (data.areaTo == null && data.areaFrom !== null)
      ) {
        return false;
      }

      const isEmptyNecessary =
        !data.pricePerSqMFrom && !data.pricePerSqMTo && !data.priceFrom && !data.priceTo;

      if (isEmptyNecessary && val === null) {
        return false;
      } else {
        if (val !== null && data.areaTo && val! > data.areaTo) {
          return false;
        }
        return true;
      }
    })
    .nullable(),
  pricePerSqMTo: number()
    .test(
      'pricePerSqMTo',
      `Значение не указано или ценовой диапазон привышает 50 000 ${RUBLE_SIGN}`,
      (val, form) => {
        const data = form.parent as ISchemaDataNotificationFilter;

        if (
          (data.pricePerSqMTo !== null && data.pricePerSqMFrom === null) ||
          (data.pricePerSqMTo == null && data.pricePerSqMFrom !== null)
        ) {
          return false;
        }

        const isEmptyNecessary = !data.priceTo && !data.priceFrom && !data.areaFrom && !data.areaTo;

        if (isEmptyNecessary && !val) {
          return false;
        } else {
          const isInvalid =
            val && data.pricePerSqMFrom !== null && val > data.pricePerSqMFrom + 50000;
          if ((val && data.pricePerSqMFrom && val < data.pricePerSqMFrom) || isInvalid) {
            return false;
          }
          return true;
        }
      },
    )
    .nullable(),
  pricePerSqMFrom: number()
    .test('pricePerSqMFrom', `Укажите значение цены за ${squareMetre}`, (val, form) => {
      const data = form.parent as ISchemaDataNotificationFilter;

      if (
        (data.pricePerSqMTo !== null && data.pricePerSqMFrom === null) ||
        (data.pricePerSqMTo == null && data.pricePerSqMFrom !== null)
      ) {
        return false;
      }

      const isEmptyNecessary = !data.priceTo && !data.priceFrom && !data.areaFrom && !data.areaTo;

      if (isEmptyNecessary && val === null) {
        return false;
      } else {
        if (val !== null && data.pricePerSqMTo && val! > data.pricePerSqMTo) {
          return false;
        }
        return true;
      }
    })
    .nullable(),
});
